(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-brand-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.ws-bt').forEach(function (section) {
    var tabs = section.querySelectorAll('.ws-bt__tab');
    var grid = section.querySelector('.ws-bt__grid');
    var cta  = section.querySelector('[id^="ws-bt-cta-"]');
    var sectionId = grid ? grid.getAttribute('data-section') : null;
    if (!tabs.length || !grid || !sectionId) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var handle = tab.getAttribute('data-handle');
        if (!handle) return;

        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', 'false');
          t.classList.remove('is-active');
        });
        tab.setAttribute('aria-selected', 'true');
        tab.classList.add('is-active');

        if (cta) cta.href = '/collections/' + handle;

        grid.classList.add('is-loading');
        fetch('/collections/' + handle + '?sections=' + sectionId)
          .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
          .then(function (data) {
            var html = data[sectionId];
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('.ws-bt__grid');
            if (newGrid) grid.innerHTML = newGrid.innerHTML;
          })
          .catch(function () {})
          .finally(function () { grid.classList.remove('is-loading'); });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
